import AcceptInviteForm from '@/components/forms/auth/AcceptInviteForm'
import { Meta } from '@cfs-fixings/shared'

function AcceptInvitePage () {
  return <>
    <Meta title="Accept Invitation" />

    <div className="flex justify-center w-full mt-[110px]">
      <AcceptInviteForm />
    </div>
  </>
}

export default AcceptInvitePage
